import api from '@/services/api';

export interface Language {
    code: string;
    name: string;
    native_name: string;
    is_active: boolean;
    is_default: boolean;
    direction: 'ltr' | 'rtl';
    flag_url?: string;
}

export const languageService = {
    getAll: async () => {
        const response = await api.get<Language[]>('/admin/languages');
        return response.data;
    },
    getActive: async () => {
        // Using admin endpoint for now as we are in admin area
        const response = await api.get<Language[]>('/admin/languages');
        return response.data.filter(l => l.is_active);
    },
    create: async (data: Omit<Language, 'is_default'>) => {
        const response = await api.post<Language>('/admin/languages', data);
        return response.data;
    },
    update: async (code: string, data: Partial<Omit<Language, 'code' | 'is_default'>>) => {
        const response = await api.put<Language>(`/admin/languages/${code}`, data);
        return response.data;
    },
    delete: async (code: string) => {
        await api.delete(`/admin/languages/${code}`);
    },
    setDefault: async (code: string) => {
        const response = await api.post<Language>(`/admin/languages/${code}/default`);
        return response.data;
    },
    validate: async (code: string) => {
        const response = await api.get<{
            is_complete: boolean;
            missing: string[];
            can_activate: boolean;
        }>(`/admin/languages/${code}/validate`);
        return response.data;
    }
};

